import { render, staticRenderFns } from "./PaymentOrderLayout.vue?vue&type=template&id=4b316d1a&scoped=true&lang=pug&"
import script from "./PaymentOrderLayout.vue?vue&type=script&lang=js&"
export * from "./PaymentOrderLayout.vue?vue&type=script&lang=js&"
import style0 from "./PaymentOrderLayout.vue?vue&type=style&index=0&id=4b316d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b316d1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VApp,VDivider})
